export default __webpack_public_path__ + "static/media/Shape_right.4f473f02.png";